import type { Signee } from '@/types/Signee.ts';
import type { AutographPosition } from '@/types/AutographPosition.ts';

export function useInviteesSignaturePlacement(store) {
  const createStore = store;

  // Removes a signee's signature placements. When `fileId` is provided the
  // payload only clears that file (`{ [fileId]: [] }`) — the backend merges per
  // file, so every other file's positions are preserved without re-sending
  // them. Without a `fileId` every known file is cleared (full removal).
  async function removeSignature(eventData: { id: string; fileId?: string }) {
    try {
      const signee = createStore.filteredSignees.find(
        (signee: Signee) => signee.signeeId === eventData.id
      );

      const fileAutographPositions: Record<string, AutographPosition[]> = {};
      if (eventData.fileId) {
        fileAutographPositions[eventData.fileId] = [];
      } else {
        signee?.signings?.forEach((signing) => {
          fileAutographPositions[signing.fileId] = [];
        });
      }

      const payload = {
        email: signee?.email || null,
        comment: signee?.signeeComment || null,
        autographPosition: signee?.autographPosition ?? null,
        fileAutographPositions
      };
      const response = await createStore.updateInvitee(
        createStore.document!.documentId,
        signee.signeeId,
        payload
      );
      createStore.updateInviteeInLocalData(response.data);
    } catch (error) {
      console.error('Error removing signature ', error);
    }
  }

  return {
    removeSignature
  };
}
